import React from "react";
import "./Pyment.css";

const PaymentSummaryModal = ({ show, onClose, slot, pageNo, onBookClick }) => {
  if (!show || !slot) return null;

  const {
    amount = 0,
    gstPercentage = 0,
    gstAmount = 0,
    totalAmount = 0,
  } = slot;

  return (
    <div className="payment-overlay">
      <div className="payment-card">
        <div className="payment-header">
          <div className="icon-wrapper">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="url(#gradient)"/>
              <defs>
                <linearGradient id="gradient" x1="2" y1="12" x2="22" y2="12">
                  <stop offset="0%" stopColor="#2e7d32"/>
                  <stop offset="100%" stopColor="#43a047"/>
                </linearGradient>
              </defs>
            </svg>
          </div>
          <h5 className="payment-title">Payment Summary</h5>
          <p className="payment-subtitle text-light">Please Complete the Payment !</p>
        </div>

        <div className="payment-details">
          <div className="detail-card">
            <div className="payment-row">
              <span className="label">Base Amount</span>
              <span className="value">₹{amount.toFixed(2)}</span>
            </div>

            <div className="payment-row">
              <span className="label">
                GST <span className="percentage">({gstPercentage}%)</span>
              </span>
              <span className="value">₹{gstAmount.toFixed(2)}</span>
            </div>
          </div>

          <div className="total-section">
            <div className="payment-row total">
              <span className="total-label">Total Amount</span>
              <span className="total-value">₹{totalAmount.toFixed(2)}</span>
            </div>
          </div>
        </div>

        <div className="payment-actions">
          <button className="btn-cancel" onClick={onClose}>
            <span>Cancel</span>
          </button>

          <button className="btn-pay" onClick={() => onBookClick(slot)}>
            <span>Proceed to Pay</span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="white"/>
            </svg>
          </button>
        </div>
      </div>
      <style jsx>{`
        /* Overlay */
        .payment-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(4px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          animation: fadeIn 0.2s ease-out;
        }

        /* Card */
        .payment-card {
          background: linear-gradient(135deg, #ffffff 0%, #f8fdf9 100%);
          width: 380px;
          border-radius: 24px;
          padding: 0;
          box-shadow: 0 20px 60px rgba(46, 125, 50, 0.2);
          animation: slideUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
          overflow: hidden;
          border: 1px solid rgba(46, 125, 50, 0.1);
        }

        /* Header */
        .payment-header {
          background: linear-gradient(135deg, #2e7d32 0%, #43a047 100%);
          padding: 32px 24px 24px;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .payment-header::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
          animation: shimmer 3s infinite;
        }

        .icon-wrapper {
          background: rgba(255, 255, 255, 0.2);
          width: 64px;
          height: 64px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 16px;
          backdrop-filter: blur(10px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
        }

        /* Title */
        .payment-title {
          color: #ffffff;
          font-weight: 700;
          font-size: 24px;
          margin: 0 0 8px 0;
          position: relative;
          z-index: 1;
        }

        /* Subtitle */
        .payment-subtitle {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.9);
          margin: 0;
          font-weight: 500;
          position: relative;
          z-index: 1;
        }

        /* Details */
        .payment-details {
          padding: 24px;
        }

        .detail-card {
          background: #ffffff;
          border-radius: 16px;
          padding: 20px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
          margin-bottom: 16px;
        }

        /* Rows */
        .payment-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
        }

        .payment-row:last-child {
          margin-bottom: 0;
        }

        .label {
          font-size: 15px;
          color: #666;
          font-weight: 500;
        }

        .percentage {
          color: #999;
          font-size: 13px;
        }

        .value {
          font-size: 16px;
          color: #2e7d32;
          font-weight: 600;
        }

        /* Total Section */
        .total-section {
          background: linear-gradient(135deg, #2e7d32 0%, #43a047 100%);
          border-radius: 16px;
          padding: 20px;
          box-shadow: 0 4px 16px rgba(46, 125, 50, 0.2);
        }

        .payment-row.total {
          margin-bottom: 0;
        }

        .total-label {
          font-size: 16px;
          color: #ffffff;
          font-weight: 600;
        }

        .total-value {
          font-size: 24px;
          color: #ffffff;
          font-weight: 700;
        }

        /* Actions */
        .payment-actions {
          display: flex;
          gap: 12px;
          padding: 0 24px 24px;
        }

        .btn-cancel,
        .btn-pay {
          flex: 1;
          border: none;
          border-radius: 12px;
          padding: 14px 20px;
          font-weight: 600;
          font-size: 15px;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .btn-cancel {
          background: #f5f5f5;
          color: #666;
          border: 2px solid #e0e0e0;
        }

        .btn-cancel:hover {
          background: #eeeeee;
          border-color: #d0d0d0;
          transform: translateY(-1px);
        }

        .btn-pay {
          background: linear-gradient(135deg, #2e7d32 0%, #43a047 100%);
          color: #fff;
          box-shadow: 0 4px 12px rgba(46, 125, 50, 0.3);
        }

        .btn-pay:hover {
          box-shadow: 0 6px 20px rgba(46, 125, 50, 0.4);
          transform: translateY(-2px);
        }

        .btn-pay:active,
        .btn-cancel:active {
          transform: translateY(0);
        }

        /* Animations */
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            transform: translateY(30px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes shimmer {
          0%, 100% {
            transform: rotate(0deg);
          }
          50% {
            transform: rotate(180deg);
          }
        }

        /* Responsive */
        @media (max-width: 480px) {
          .payment-card {
            width: 340px;
            margin: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default PaymentSummaryModal;